import { render, staticRenderFns } from "./ReportIndividualDetail.vue?vue&type=template&id=03da1d1e&scoped=true&"
import script from "./ReportIndividualDetail.vue?vue&type=script&lang=ts&"
export * from "./ReportIndividualDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ReportIndividualDetail.vue?vue&type=style&index=0&id=03da1d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da1d1e",
  null
  
)

export default component.exports